import {SOPostProcess} from '../../core/process/so-post-process';
import {ProcessCore} from './process.core';
import {SOGetProcess} from '../../core/process/so-get-process';
import {FormField, SelectionOption} from 'lionheartland';
import {postProcessFormFieldOptions} from './post-process-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostProcess extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postProcessFormFieldOptions);

  RequestClass = SOPostProcess

  constructor(
    public entityCore: ProcessCore
  ) {
    super();
    if (postProcessFormFieldOptions.project) {
      postProcessFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}